import {IChangePassword, ICredentials, IForgotPassword, IResetPassword} from '@evencel/models';

export class SignIn {
    public static readonly type = '[Login] SignIn';
    constructor(public credentials: ICredentials) {}
}

/**
 * Inform the backend to logout to invalidate the refresh token
 */
export class SignOut {
    public static readonly type = '[Login] SignOut';
}

export class Logout {
    public static readonly type = '[Login] Logout';
}

export class ResetPassword {
    public static readonly type = '[Login] ResetPassword';
    constructor(public resetPassword: IResetPassword) {}
}

export class ChangePassword {
    public static readonly type = '[Login] ChangePassword';
    constructor(public changePassword: IChangePassword, public qp?: Record<string, boolean>) {}
}

export class ForgotPassword {
    public static readonly type = '[Login] ForgotPassword';
    constructor(public iForgotPassword: IForgotPassword) {}
}

export class GetPolicies {
    public static readonly type = '[Login] GetPolicies';
}
